import React from "react";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";

const Footer = () => {
  const quickLinksCol1 = [
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Blog", path: "/blog" },
  ];
  const quickLinksCol2 = [
    { label: "Contact", path: "/contact" },
    { label: "Influencer", path: "/influencer" },
    { label: "UpSkill", path: "/upskill" },
  ];

  return (
    <footer className="bg-white border-t border-gray-200 w-full">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-20 pb-12">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12 pb-12 border-b border-gray-200">
          {/* Company Info */}
          <div className="flex flex-col gap-6">
            <img 
              src={Logo} 
              alt="Cyborg Sapient - AI & Digital Transformation Solutions" 
              className="h-12 w-auto object-contain"
              loading="lazy"
            />
            <p className="text-sm font-light text-gray-600 leading-relaxed max-w-xs">
              The growth engine behind your digital presence.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=100085886838636" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-400 transition-colors duration-200" 
                aria-label="Facebook"
              >
                <FaFacebookF size={18} />
              </a>
              <a 
                href="https://www.instagram.com/cyborgsapient/?fbclid=IwY2xjawPcJgZleHRuA2FlbQIxMQBicmlkETFGT2txbXVmU2lsRFFOeUdXc3J0YwZhcHBfaWQBMAABHjvM6qnAhnal3VpNybubhSH3_UAIGdaO64lamBHJyGVoa1nEu6gzmMTGDaMP_aem_48Tq_gg8_wiFjqdAu_jkQg" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-purple-400 transition-colors duration-200" 
                aria-label="Instagram"
              >
                <FaInstagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links Column 1 */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-6 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-4">
              {quickLinksCol1.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.path}
                    className="text-gray-600 hover:bg-gradient-to-r hover:from-orange-400 hover:via-pink-400 hover:to-purple-400 hover:bg-clip-text hover:text-transparent transition-all duration-200 text-sm font-light"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Column 2 */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-6 text-sm uppercase tracking-wider">Resources</h3>
            <ul className="space-y-4">
              {quickLinksCol2.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.path}
                    className="text-gray-600 hover:bg-gradient-to-r hover:from-orange-400 hover:via-pink-400 hover:to-purple-400 hover:bg-clip-text hover:text-transparent transition-all duration-200 text-sm font-light"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-6 text-sm uppercase tracking-wider">Contact</h3>
            <div className="space-y-4 text-sm font-light">
              <div className="flex items-start gap-3">
                <div className="mt-1 flex-shrink-0">
                  <FaMapMarkerAlt className="text-orange-400" size={16} />
                </div>
                <div className="text-gray-600 space-y-1">
                  <p>India Office: Pooja Garden, Kalkere, Bangalore</p>
                  <p>USA Office: 7901 4th St N #21879, St Petersburg, FL 33702, USA</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <FaEnvelope className="text-pink-400 flex-shrink-0" size={16} />
                <a 
                  href="mailto:contact@cyborgsapient.com" 
                  className="text-gray-600 hover:bg-gradient-to-r hover:from-pink-400 hover:to-purple-400 hover:bg-clip-text hover:text-transparent transition-all duration-200"
                >
                  contact@cyborgsapient.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <FaPhoneAlt className="text-purple-400 flex-shrink-0" size={16} />
                <span className="text-gray-600">+91 9164752256</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-xs text-gray-500 mt-12 font-light">
          Copyright © 2025{" "}
          <span className="text-gray-700 font-medium">Cyborgsapient.com</span>. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
